// Synced from Tolgee at build time by scripts/sync-translations.js
import hu from './fallback/hu.json';

export default () => hu;
